<div
  class="layout-wrapper"
  [class.sidebar-open]="showSidebar"
  [class.sidebar-collapsed]="isSidebarCollapsed"
>
  @if (showSidebar) {
    <app-sidebar-wrapper
      [collapsed]="isSidebarCollapsed"
      (collapsedChange)="onSidebarCollapsedChange($event)"
    />
  }

  <!-- En pantalla angosta, el menu abierto flota: el velo lo acompaña y tocarlo lo contrae. -->
  @if (showSidebar && pantallaAngosta && !isSidebarCollapsed) {
    <div class="sidebar-velo" aria-hidden="true" (click)="cerrarMenuFlotante()"></div>
  }

  <div
    class="main-wrapper"
    [class.sidebar-open]="showSidebar"
    [class.sidebar-collapsed]="isSidebarCollapsed"
  >
    @if (showHeader) {
      <app-topbar-wrapper
        [userName]="userName()"
        [isDarkMode]="isDarkMode()"
        [logoUrl]="logoUrl()"
        [itemsProfileMenu]="itemsProfileMenu()"
        [showSearch]="showSearch()"
        [showNotifications]="showNotifications()"
        [showRefresh]="showRefresh()"
        [showSystemDate]="showSystemDate()"
        (darkModeToggle)="darkmodeChange()"
        [showProducts]="showProducts()"
        (logout)="logout()"
      />
    }

    @if (esPerfil30()) {
      <!-- Perfil 3.0: a la derecha de la miga, la dependencia y la fecha que antes iban en la
           cabecera (orden de Carlos, 22-oct-2026). -->
      @if (showBreadcrumb || showSystemDate()) {
        <div class="barra-miga">
          @if (showBreadcrumb) {
            <app-breadcrumb-wrapper class="barra-miga__miga" />
          }
          <app-contexto-sesion class="barra-miga__contexto" [mostrarFecha]="showSystemDate()" />
        </div>
      }
    } @else if (showBreadcrumb) {
      <app-breadcrumb-wrapper />
    }

    <div class="area-trabajo" [class.con-nebulina]="showNebulina">
      <main class="content">
        <router-outlet></router-outlet>
      </main>
      @if (showNebulina) {
        <app-nebulina />
      }
    </div>
    <app-footer-wrapper [variant]="footerVariant"></app-footer-wrapper>
  </div>
</div>
